import { createEntityContext } from "./createEntityContext";

export const { EntityContext: SkillContext, EntityProvider: SkillProvider } =
  createEntityContext("skills", "/api/skills");
